import React from 'react';
import {apiRoutePrefix, RouteComponent} from '../../../RouteComponent';
import {Box, Divider} from '@material-ui/core';
import ObjectHeader from '../ObjectHeader';
import {jsonObject, manufactureOrderAttributes, manufactureOrdersHeader} from '../../data/manufactureOrders/manufactureOrder';
import RequestDefinition from '../RequestDefinition';
import ObjectDefinition from '../ObjectDefinition';

export default new RouteComponent(`${apiRoutePrefix}/manufacture-orders`, () => {
    return (
        <div>
            <ObjectHeader data={ manufactureOrdersHeader }/>

            <Box mb={ 3 }>
                <Divider/>
            </Box>

            <ObjectDefinition data={ {
                title: 'The manufacture order object',
                attributes: manufactureOrderAttributes,
                jsonObject: jsonObject
            } }/>

            {
                manufactureOrdersHeader.endpoints.map(data => (
                    <>
                        <Box mb={3}>
                            <Divider/>
                        </Box>
                        <RequestDefinition {...data} />
                    </>
                ))
            }
        </div>
    );
});
